module.exports = __webpack_public_path__ + "static/prices-realized-hero-1545cf40ba85a6431e11fa306aae603d.png";